import { Tooltip, IconButton } from '@material-tailwind/react';
import { SquarePlus } from 'lucide-react';
const AddButton = ({ handleModel, css }) => {
  return (
    <Tooltip content="Adicionar">
      <IconButton variant="text" onClick={handleModel}>
        <SquarePlus className="dark:opacity-60 dark:text-darkText" />
      </IconButton>
    </Tooltip>
  );
};

export default AddButton;
